export const CHART_COLORS = [
  '#3B82F6', '#EC4899', '#10B981', '#F59E0B', '#8B5CF6',
  '#F43F5E', '#06B6D4', '#84CC16', '#F97316', '#6366F1'
] as const

export const CHART_CONFIG = {
  INNER_RADIUS: 60,
  OUTER_RADIUS: 120,
  PADDING_ANGLE: 2,
  MAX_DECIMAL_PLACES: 8,
  ANIMATION_DURATION: 300
} as const

export const CHART_THRESHOLDS = {
  MIN_PERCENTAGE_FOR_LABEL: 3,
  MIN_VALUE_FOR_DISPLAY: 0.01
} as const